import { render, staticRenderFns } from "./shopsManage_ec.vue?vue&type=template&id=5afbe429&scoped=true&"
import script from "./shopsManage_ec.vue?vue&type=script&lang=js&"
export * from "./shopsManage_ec.vue?vue&type=script&lang=js&"
import style0 from "./shopsManage_ec.vue?vue&type=style&index=0&id=5afbe429&lang=less&scoped=true&"
import style1 from "./shopsManage_ec.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afbe429",
  null
  
)

component.options.__file = "shopsManage_ec.vue"
export default component.exports